import * as p from '@clack/prompts'
import type { PromptTextOptions, SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { cancelIfNeeded } from './cancel-if-needed.js'

export async function promptText(
  context: SchemaPromptContext,
  message: string,
  optionsOrDefaultValue?: string | PromptTextOptions
): Promise<string> {
  const options =
    typeof optionsOrDefaultValue === 'string'
      ? { defaultValue: optionsOrDefaultValue }
      : (optionsOrDefaultValue ?? {})
  const value = await p.text({
    message,
    defaultValue: options.defaultValue,
    placeholder: options.placeholder,
    validate(input) {
      const result = options.validate?.(String(input ?? ''))
      if (result) {
        return result
      }
      if (!input || !String(input).trim()) {
        return 'Enter a value.'
      }
    }
  })

  return String(cancelIfNeeded(context, value)).trim()
}
